import styled  from 'styled-components';
import { string, node, func } from 'prop-types';
import MaterialIconsEot from '../assets/fonts/material-icons.eot';
import MaterialIconsTtf from '../assets/fonts/material-icons.ttf';
import MaterialIconsWoff from '../assets/fonts/material-icons.woff';
import MaterialIconsSvg from '../assets/fonts/material-icons.svg';

const IconWrapper = styled.i`
  @font-face {
    font-family: "material-icons";
    src: url(${MaterialIconsEot});
    src: url(${MaterialIconsEot}) format("embedded-opentype"), url(${MaterialIconsTtf}) format("truetype"), url(${MaterialIconsWoff}) format("woff"), url(${MaterialIconsSvg}) format("svg");
    font-weight: normal;
    font-style: normal;
  }

  font-family: "material-icons";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  /* Enable Ligatures ================ */
  letter-spacing: 0;
  -webkit-font-feature-settings: "liga";
  -moz-font-feature-settings: "liga=1";
  -moz-font-feature-settings: "liga";
  -ms-font-feature-settings: "liga" 1;
  font-feature-settings: "liga";
  -webkit-font-variant-ligatures: discretionary-ligatures;
  font-variant-ligatures: discretionary-ligatures;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  font-size: 1em;
  font-weight: bold;
  transform: scale(1.25);
`;

function Icon({children, className, onClick}) {
  return (
    <IconWrapper className={className} onClick={onClick}>{children}</IconWrapper>
  )
}

Icon.propTypes = {
  children: node.isRequired,
  className: string,
  onClick: func,
}

Icon.defaultProps = {
  className: '',
  onClick: undefined,
}

export default styled(Icon)``;